/* RESPONSIBLE TEAM: team-fin-qa */
import Model, { attr } from '@ember-data/model';

export default class CxScoreReason extends Model {
  @attr('string') declare label: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'qa-monitor/cx-score-reason': CxScoreReason;
  }
}
